export default __webpack_public_path__ + "static/media/cafmaquinas.322c55f3.jpg";